
import { Options, Vue } from "vue-class-component";

@Options({
  props: {
    percent: {
      type: Number,
      required: false,
    },
    label: {
      type: String,
      required: false,
    },
  },
  name: "CircularStats",
})
export default class CircularStats extends Vue {
  percent!: number;
  label!: string;
  get series(): number[] {
    return [this.percent];
  }

  get color(): string[] {
    if (this.percent <= 70) return ["#FF4436"];
    if (this.percent > 70 && this.percent <= 80) return ["#FF9F40"];
    if (this.percent > 80 && this.percent <= 90) return ["#FFEA36"];
    return ["#008000"];
  }

  get chartOptions(): any {
    return {
      chart: {
        type: "radialBar",
        offsetY: 0,
        sparkline: {
          enabled: true,
        },
      },
      plotOptions: {
        radialBar: {
          startAngle: -90,
          endAngle: 90,
          hollow: {
            margin: 0,
            size: "70%",
          },
          track: {
            background: "#ECECEC",
            strokeWidth: "100%",
            margin: 0,
          },
          dataLabels: {
            name: {
              show: false,
            },
            value: {
              show: false,
            },
          },
        },
      },
      fill: {
        type: "gradient",
        gradient: {
          shade: "light",
          type: "horizontal",
          gradientToColors: ["#000000"],
          stops: [0, 50, 75, 100],
          colorStops: [
            {
              offset: 0,
              color: "#FF4436",
              opacity: 1,
            },
            {
              offset: 50,
              color: "#FF9F40",
              opacity: 1,
            },
            {
              offset: 75,
              color: "#FFEA36",
              opacity: 1,
            },
            {
              offset: 100,
              color: "#008000",
              opacity: 1,
            },
          ],
        },
      },
    };
  }
}
